import classes from './secondHeader.module.css';
import { Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import umiunilogotitle from './header_logo.png'

const TopSecondHeader = (props) => {
    const navigate = useNavigate();   


    const handleHomePage = () => {
        console.log("awfawef");
        navigate('/');
    }

    return (
        <Fragment>
            <header className={classes.header}>
                <div>
                    <img src={umiunilogotitle} className={classes.logo} onClick={handleHomePage}/>
                </div>
            </header>
            <div style={{ height: '50px' }} />
        </Fragment>
    );

};

export default TopSecondHeader;
